import React from 'react';
// import { Link } from 'react-router-dom';

import {
    Link,
} from '@material-ui/core';

import AuthBody from '../AuthBody';
import AuthBodyTitle from '../AuthBodyTitle';
import AuthBodyButton from '../AuthBodyButton';
import AuthBodyContent from '../AuthBodyContent';

const CONTACT_US_URL = "https://www.landhawk.uk/contact/";

function VerifyingBody () {
    return (
        <AuthBody>
            <AuthBodyTitle>
                We are verifying your account
            </AuthBodyTitle>
            <AuthBodyContent variant="h4">
                Thank you for registering for LandHawk!
            </AuthBodyContent>
            <AuthBodyContent>
                Your Account Manager will be in touch within 24 hours to discuss the payment process and confirm access following successful completion.
                <br />
                <br />
                If you have any immediate questions please contact the team. Otherwise, we look forward to working together!
            </AuthBodyContent>
            <Link href={CONTACT_US_URL} target="_blank">
                <AuthBodyButton>
                    Contact the team
                </AuthBodyButton>
            </Link>     
        </AuthBody>
    );
}

export default VerifyingBody;